module.exports = __webpack_public_path__ + "static/media/NotoSans-Bold.e6ee53a5.otf";